import {zodResolver} from '@hookform/resolvers/zod';
import {useForm} from 'react-hook-form';

import useEmmai from '../../../../../../../hooks/providers/useEmmai';
import useReport from '../../../../../../../hooks/providers/useReport';
import {parentFormSchema} from '../../helpers/schema';
import useMonthlyRestitutionFormData from '../useMonthlyRestitutionFormData/useMonthlyRestitutionFormData';
import useSubmitMonthlyRestitution from '../useSubmitMonthlyRestitution/useSubmitMonthlyRestitution';

export const useMonthlyRestitutionForm = () => {
  const {currentForm, emmaiData, formattedEmmaiRestitutionSelectedDate, addActivities} = useEmmai();
  const {selectedProject} = useReport();

  const methods = useForm({
    resolver: zodResolver(parentFormSchema),
    mode: 'all',
    defaultValues: {
      officeInformation: {},
      practitionerActivity: {}
    }
  });

  useMonthlyRestitutionFormData({
    emmaiData,
    formattedEmmaiRestitutionSelectedDate,
    selectedProject,
    methods
  });

  const submit = useSubmitMonthlyRestitution({
    currentForm,
    emmaiData,
    selectedProject,
    formattedEmmaiRestitutionSelectedDate,
    methods,
    addActivities
  });

  return {
    methods,
    onSubmit: submit.onSubmit,
    submitDisabled: submit.submitDisabled
  };
};
